export type Data = {
  strategicNumberOfProcurements?: number;
  strategicAverageContractValue?: number;
  strategicNumberOfEvaluators?: number;
  strategicAverageDuration?: number;
  majorNumberOfProcurements?: number;
  majorAverageContractValue?: number;
  majorNumberOfEvaluators?: number;
  majorAverageDuration?: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  organisation?: string;
};

export type FormProps = {
  formDetails: FormDetails[];
  setErrorMessage: (
    index: number,
    type: ErrorsType,
    message: InputError,
  ) => void;
  inputErrors: { strategicErrors: InputError[]; majorErrors: InputError[] };
};

export type InputErrorActionType = {
  type: string;
  payload: {
    index: number;
    message: InputError;
  };
};

// Error messages are produced by i18next's t() (translated, and locale-specific),
// so the runtime type is a plain string; "" represents "no error".
export type InputError = string;

export type DetailsErrorActionType = {
  type: keyof Data;
  payload: DetailsError;
};

export type DetailsError = "Required" | "Invalid Email" | "";

export enum ErrorMessageEnum {
  STRATEGIC = "strategicErrors",
  MAJOR = "majorErrors",
}

export type InputData = {
  inputData?: Data;
  setInputData?: (data: Data) => void;
};

export type ErrorsType = "strategicErrors" | "majorErrors";

export type FormDetails = {
  // title and placeholder are populated from translations (t()), so they are strings.
  title: string;
  placeholder: string;
  border: boolean;
  inputId1: keyof Data;
  inputId2: keyof Data;
  errorsType1: ErrorsType;
  errorsType2: ErrorsType;
};

export type Locale = "en" | "es";

export type PieChartData = {
  id: number;
  label: string;
  savings: number;
};

export type ImageInfo = {
  id: number;
  text: string;
};
